import {
  Component,
  HostListener,
  inject,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NavigationEnd, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { ViewPath } from '../../constants/ViewPath';
import { MenuComponent } from '../../components/menu/menu.component';
import { feature } from '../../utils/FeaturesController';
import { PermissionsEnum } from '../../enums/PermissionsEnum';
import { RolesEnum } from '../../enums/RolesEnum';
import { EnumSubscription } from '../../enums/EnumSubscription';
import { UserService } from '../../services/user.service';
import { ModulesEnum } from '../../enums/ModulesEnum';
import { ResponsiveService } from '../../services/responsive.service';
import { StorageService } from '../../services/storage.service';
import { SvgIconsService } from '../../services/svg-icons.service';
import { RouterService } from '../../services/router.service';
import { EntryPointService } from '../../services/entry-point.service';
import { SessionService } from '../../services/session.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DeveloperHelperComponent } from '../../components/developer-helper/developer-helper.component';
import { ChatInternalWidgetComponent } from '../../components/chat-internal/chat-internal-widget/chat-internal-widget.component';
import { SnackService } from '../../services/snack.service';
//import Clarity from '@microsoft/clarity';
import { LoadingPanelService } from '../../services/LoadingPanel/loading-panel.service';
import { environment } from '../../../environments/environment';
import { ReferenceService } from '../../services/onboarding.service';
import { WifiCheckerComponent } from '../../components/wifi-checker/wifi-checker.component';
import { CommonModule } from '@angular/common';
import { MatDrawer, MatDrawerContainer, MatDrawerContent } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ErrorViewerComponent } from '../../components/error-viewer/error-viewer.component';
import { AppContentsComponent } from '../../components/app-contents/app-contents.component';
import { ToolbarComponent } from '../../components/toolbar/toolbar.component';
import { BackofficeFeedbackService } from '../../services/backoffice-feedback.service';

@Component({
  selector: 'app-entry-point',
  templateUrl: './entry-point.component.html',
  styleUrls: ['./entry-point.component.css'],
  standalone: true,
  imports: [
    WifiCheckerComponent,
    CommonModule,
    MatDrawerContainer,
    MatDrawer,
    MenuComponent,
    MatDrawerContent,
    MatButtonModule,
    MatTabsModule,
    DeveloperHelperComponent,
    ChatInternalWidgetComponent,
    MatSlideToggleModule,
    ErrorViewerComponent,
    RouterOutlet,
    AppContentsComponent,
    ToolbarComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [ReferenceService],
})
export class EntryPointComponent {
  //DEBUG
  private static instanceCount = 0;
  private instanceId = ++EntryPointComponent.instanceCount;
  //--

  public responsive = inject(ResponsiveService);
  private router = inject(Router);
  private entrypointS = inject(EntryPointService);
  public storageS = inject(StorageService);
  private routerS = inject(RouterService);
  private sessionS = inject(SessionService);
  public refService = inject(ReferenceService);
  private svgS = inject(SvgIconsService);
  public userS = inject(UserService);
  private matIconReg = inject(MatIconRegistry);
  private snackService = inject(SnackService);
  private loadingS = inject(LoadingPanelService);

  @ViewChild(DeveloperHelperComponent) developerHelper?: DeveloperHelperComponent;
  v = ViewPath;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.responsive.width = event.target.innerWidth;
  }

  isPhone = this.responsive.isPhone();

  re = RolesEnum;
  mod = ModulesEnum;
  perms = PermissionsEnum;
  feature = feature;
  displayToolbar = false;
  es = EnumSubscription;
  items!: any[];
  allModules = this.getAllModules();
  env = environment;

  userinput: string[] = [];
  keyWorkds = ['help', 'ayuda', 'design', 'diseño', 'docu'];
  dHelper = ['developer'];
  dialog = ['onboarding', 'welcome'];
  changeMatLabels = ['backend'];
  showloading = ['loading'];
  workloadDrag = ['dragtuto'];
  garantiasDialog = ['garantia', 'garantias'];
  toJira = ['jira', 'tojira', 'to jira'];
  componentName = ['ccc'];
  quickOr = ['quick'];

  /** Keyboard commands shortcuts */
  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (environment.production) {
      return;
    }

    if (this.userinput.length == 30) {
      this.userinput.splice(0, 10);
    }

    this.userinput.push(event.key.toLocaleLowerCase());

    for (let i = 0; i < this.userinput.length; i++) {
      for (let j = i + 1; j <= this.userinput.length; j++) {
        const subcadena = this.userinput.slice(i, j).join('');

        if (feature.forntendDocu) {
          if (this.keyWorkds.includes(subcadena)) {
            this.userinput = [];
            return;
          }
        }

        if (!environment.production) {
          if (this.changeMatLabels.includes(subcadena)) {
            this.updateMatLabels();
            this.userinput = [];
            return;
          }
        }
        if (environment.local) {
          if (this.showloading.includes(subcadena)) {
            this.loadingS.show();
            this.userinput = [];
            return;
          }
        }

        if (feature.developerHelper) {
          if (this.dHelper.includes(subcadena)) {
            this.developerHelper?.setMaximized();
            this.userinput = [];
            return;
          }
        }

        if (this.toJira.includes(subcadena)) {
          try {
            const user = this.userS.user;
            navigator.clipboard.writeText(
              '**URL:** ' +
                window.location.href +
                '\n\n' +
                '**Company**' +
                '\n' +
                //"Nombre: " + company.name + "\n" +
                //"Id: " + company.id + "\n\n" +

                '**Center**' +
                '\n' +
                //"Nombre: " + center.name + "\n" +
                //"Id: " + center.id + "\n\n" +

                '**User**' +
                '\n' +
                'Nombre: ' +
                user.name +
                '\n' +
                'Id: ' +
                user.id +
                '\n\n',
            );
            if (!environment.production) {
              this.snackService.show(
                'Se ha copiado la URL, los datos de la compañía, centro y usuario 📋',
              );
            }
          } catch {}
          this.userinput = [];
          return;
        }

        if (this.componentName.includes(subcadena)) {
          this.loadingS.show();

          const observer = new MutationObserver(() => {
            document.querySelectorAll('*').forEach((el) => {
              const tag = (el as HTMLElement).tagName.toLowerCase();

              if (tag.startsWith('app-') && !(el as HTMLElement).hasAttribute('data-tag-label')) {
                const label = document.createElement('span');
                label.textContent = tag;
                label.style.cssText = `
                  position: absolute;
                  top: 2px;
                  left: 2px;
                  background: rgba(255,0,0,0.1);
                  color: #c00;
                  font-size: 10px;
                  padding: 1px 3px;
                  border-radius: 3px;
                  pointer-events: none;
                  opacity: 0;
                  transition: opacity 0.2s;
                  z-index: 9999;
                `;

                const host = el as HTMLElement;
                host.style.position = 'relative';
                host.appendChild(label);
                host.setAttribute('data-tag-label', tag);

                // Mostrar solo al pasar el mouse
                host.addEventListener('mouseenter', () => (label.style.opacity = '1'));
                host.addEventListener('mouseleave', () => (label.style.opacity = '0'));
              }
            });
          });

          observer.observe(document.body, { childList: true, subtree: true });

          this.loadingS.hide();

          this.userinput = [];
          return;
        }
      }
    }
  }

  private feedbackS = inject(BackofficeFeedbackService);

  constructor() {
    this.items = this.storageS.getAllStorage();
    this.matIconReg.setDefaultFontSetClass('material-symbols-outlined');
    this.svgS.addSvgIcons(
      'wheel',
      'wheel_outline',
      'bizum',
      'damages_bike',
      'file-pdf',
      'eina',
      'no_provider',
      'reserve',
      'reserve_active',
      'eina_stepper0',
      'eina_stepper1',
      'eina_stepper2',
      'eina_stepper3',
      'eina_documentation',
      'whatsapp',
    );

    this.responsive.width = window.innerWidth;
    this.responsive.onResize.subscribe((val) => {
      this.isPhone = this.responsive.isPhone();
    });

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        window.scroll(0, 0);
      }
      if (val instanceof NavigationEnd) {
        const needsToolbar = this.entrypointS.currentViewNeedToolbar();
        //this.displayToolbar = needsToolbar;
        this.displayToolbar = true;
        const hasSession = this.sessionS.hasSession();

        if (this.displayToolbar && !hasSession) {
          console.log('🔍 Redirecting to login');
          this.routerS.goTo(this.v.login);
        }
      }
    });
  }

  /** ---------------- */
  /** Developer helper */
  /** ---------------- */
  toggleMenu(menu: MenuComponent, phonemenu: MenuComponent) {
    this.responsive.isPhone() ? phonemenu.toggle() : menu.toggle();
  }

  setRole(n: RolesEnum) {}

  rIs(n: RolesEnum) {
    return this.userS.getRole() == n;
  }

  getAllModules(): [string, number][] {
    const enumKeys = Object.keys(ModulesEnum) as Array<keyof typeof ModulesEnum>;
    const enumValues = enumKeys.filter((key) => !isNaN(Number(ModulesEnum[key])));
    return enumValues.map((key) => [key, ModulesEnum[key]] as [string, number]);
  }

  onChangeModule(val: number) {}

  hasPermission(permission: string): boolean {
    if (this.userS.permisssions.includes('*' as PermissionsEnum)) {
      return true;
    }
    return this.userS.permisssions.includes(permission as PermissionsEnum);
  }

  updateMatLabels(): void {
    const matFormFields = document.querySelectorAll('mat-form-field');
    const customs = document.querySelectorAll('form-control-name-dev-info');
    matFormFields.forEach((matField) => {
      this.addP(matField);
    });
    customs.forEach((matField) => {
      this.addP(matField);
    });
    console.log(
      'Added <p> with formControlName values, including mat-select and class-searcher-developer-info',
    );
  }

  addP(tag: Element) {
    // Buscar input, textarea, mat-select y class-searcher-developer-info
    const input = tag.querySelector('input, textarea, select');
    const select = tag.querySelector('mat-select');
    const formInfo = tag.querySelector('form-info');
    const controlElement = input || select || formInfo;

    if (controlElement) {
      let formControlName = controlElement.getAttribute('formControlName');

      // Si no tiene formControlName, intenta obtenerlo desde Angular
      if (!formControlName) {
        formControlName = controlElement.getAttribute('ng-reflect-form-control-name');
      }

      if (!formControlName) {
        formControlName = controlElement.getAttribute('custom-fcn');
      }

      if (formControlName) {
        // Verifica si ya existe el <p> para evitar duplicados
        if (!tag.querySelector('.backend-helper')) {
          const pElement = document.createElement('p');
          pElement.textContent = `formControlName: ${formControlName}`;
          pElement.classList.add('backend-helper');
          pElement.style.color = 'red';
          pElement.style.fontSize = '12px';
          pElement.style.marginTop = '4px';

          // Insertar el <p> después del input, mat-select o class-searcher-developer-info
          controlElement.insertAdjacentElement('afterend', pElement);
        }
      }
    }
  }

  clearNonEssentialStorage() {
    this.storageS.clearNotMappedKeys();
  }
}
